import { head } from 'ramda'
import React from 'react'

import { useFormsState } from '../_load/FormsLoader'
import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useRowsActions } from './_actions/rowsActions'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const { forms, formsCount } = useFormsState()

  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedForms = getSelectedData(forms)
  const [menuOptions, loading] = useRowsActions(head(selectedForms), selecteds)

  return <MultiSelectMenu loading={loading} options={menuOptions} />
}

export default MultiRowsActions
